import { IDirectoryEntity } from "@/ContactDirectory/Models/IDirectoryEntity";
import { IGetDisplayName } from "@/ContactDirectory/Models/IGetDisplayName";
import { PharmacyProxy } from "@/ContactDirectory/Models/PharmacyProxy";

export class FaxDirectorySearchResultItem implements IGetDisplayName {
    public readonly id: string;
    public entity?: IDirectoryEntity;
    public preferredPharmacy?: PharmacyProxy;
    public orderNumber?: number;
    public selectedFaxNumberId?: string;

    public constructor(init?: Partial<FaxDirectorySearchResultItem>) {
        Object.assign(this, init);
        this.id = this.entity?.id ?? this.preferredPharmacy?.getId();
    }

    public getDisplayName(): string {
        return this.entity?.getDisplayName()
            ?? this.preferredPharmacy?.getDisplayName()
            ?? "";
    }
}
